import { render } from "./Password.vue?vue&type=template&id=f4ceed3c"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"
script.render = render

export default script